import React, { FC } from 'react';

import FloatingBottomNav from '../../../../../components/FloatingBottomNav';
import ComposeContainer from '../../../../../containers/compose';
import ComposeDraftContainer from '../../../../../containers/compose/composeDraft';
import OpenComposeButton from '../../../../../containers/openComposeButton';
import useParamTopicId from '../../../../../hooks/router/params/useParamTopicId';

import useComposeModeShown from '../../../../../hooks/router/search/useComposeModeShown';
import useCurrentPath from '../../../../../hooks/useCurrentPath';
import useIsMobile from '../../../../../hooks/useIsMobile';
import { getCanCreateMessage } from '../../../../../utils/permissions/message';

import { getShouldShowButtonCreate } from './helpers';
import useFeedNavigation from './hooks/useFeedNavigation';

/**
 * Component that shows feed footer
 *
 * @returns Topic footer component
 */
const FeedFooter: FC = () => {
  const currentPath = useCurrentPath();
  const isMobile = useIsMobile();
  const topicId = useParamTopicId();
  const shouldShowButtonCreate = getShouldShowButtonCreate(
    getCanCreateMessage(),
    currentPath,
    topicId,
  );
  const shouldShowCompose = useComposeModeShown();
  const { shouldShowDraft, shouldShowNavigation } = useFeedNavigation();

  return (
    <>
      {shouldShowCompose && <ComposeContainer nodeType="MESSAGE" />}
      {shouldShowNavigation && (
        <FloatingBottomNav
          floatingButton={
            <>
              {shouldShowButtonCreate && (
                <OpenComposeButton nodeType="MESSAGE" />
              )}
              {isMobile && (
                <ComposeDraftContainer
                  nodeType="MESSAGE"
                  shouldShow={shouldShowDraft}
                />
              )}
            </>
          }
        />
      )}
    </>
  );
};

export default FeedFooter;
